export const b64EncodeUnicode = (str: string) => {
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            // @ts-ignore
            return String.fromCharCode('0x' + p1)
        })
    )
}

export const andConcat = (strings: string[]) => {
    let lastItem = strings.length > 1 ? strings.pop() : undefined
    if (!lastItem) {
        // array empty or length 1
        return strings.join()
    }
    lastItem = ` and ${lastItem}`

    return strings.join(', ') + lastItem
}

export function trim(str: string, chars: string | string[]) {
    let start = 0
    let end = str.length
    while (start < end && chars.indexOf(str[start]) >= 0) ++start
    while (end > start && chars.indexOf(str[end - 1]) >= 0) --end
    return start > 0 || end < str.length ? str.substring(start, end) : str
}

export const camelToSnake = (str: string): string => {
    if (!str) return str

    return str
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        .toLowerCase()
}
